var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kvass-read-more",class:{
    'kvass-read-more--expanded': _vm.expanded,
    'kvass-read-more--active': _vm.active,
    [`kvass-read-more--placement-${_vm.placement}`]: true,
  },style:({ '--limit': _vm.expanded ? 1e6 : _vm.limit }),attrs:{"data-label":_vm.expanded ? _vm.labels.less : _vm.labels.more},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }